import { render, staticRenderFns } from "./CreateTicketOld.vue?vue&type=template&id=8ab2bfa2&scoped=true"
import script from "./CreateTicketOld.vue?vue&type=script&lang=js"
export * from "./CreateTicketOld.vue?vue&type=script&lang=js"
import style0 from "./CreateTicketOld.vue?vue&type=style&index=0&id=8ab2bfa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ab2bfa2",
  null
  
)

export default component.exports